import { Ability } from '@casl/ability'
import { initialAbility } from './config'
const existingAbility = JSON.parse(localStorage.getItem('userAbility'))
export default new Ability(existingAbility || initialAbility)
